const TermsOfUse = () => {
  return (
    <div className="w-3/4 bg-[#04152d] p-4 text-white leading-8">
      <h2 className="text-[32px] font-bold mb-4">Termes et conditions</h2>
      <h3>Avant votre achat sur la plateforme</h3>
      1. Conditions générales de vente
      <br></br>
      1.1. Les présentes Conditions Générales de Vente (CGV) sont applicables à
      tous les Articles proposés à la vente sur l’application motickets.ma.
      <br></br>
      1.2. Toute Commande sur l’application est subordonnée à la consultation et
      à l’acceptation préalables et inconditionnelles par le Client des
      présentes CGV et des tarifs applicables.
      <br></br>
      1.3. L’application a été développée dans le respect de la législation
      marocaine et notamment de la loi n° 53-05 relative à l’échange
      électronique de données juridiques.
      <br></br>
      1.4. Veuillez lire attentivement les Conditions Générales de Vente (CGV)
      ci-dessous avant de commander tout produit ou service sur Motickets.ma.
      <br></br>
      1.5. passant commande sur notre application, quel que soit le moyen
      utilisé, vous acceptez de vous soumettre aux présentes Conditions
      Générales de Vente.
      <br></br>
      <br />
      2. Définitions <br></br>
      2.1. « Contrat » fait référence aux présentes Conditions générales (CGV),
      à la Politique de confidentialité, aux Informations de paiement et à tout
      autre élément que nous vous fournissons ;<br></br>
      2.2. Vous », « Votre » et « Vos » la personne qui accède au Site Web et
      passe une commande pour un bien ou un service que nous y proposons
      (billets). L’accès à Motickets.ma par tout autre moyen vous lie également
      aux présentes Conditions Générales ;<br></br>
      2.3. www.motickets.co.uk est un site (« notre site ») exploité par Atendi
      Ltd (« Nous »). Nous sommes immatriculés en Angleterre et au Pays de
      Galles sous le numéro d’entreprise 14185160 et notre siège social est
      situé au 150 Midsummer Boulevard, Milton Keynes, MK9 1FD, Angleterre. Nous
      sommes une société anonyme.
      <br></br>
      2.4. Pour nous contacter, veuillez contact@thebizznez.com envoyer un
      e-mail ou téléphoner à notre service clientèle au +447830006598 <br />
      2.5. « Produits » et « biens » désignent l’ensemble des produits que nous
      proposons à la vente sur notre application ;<br></br>
      2.6. « Service » ou « Services » fait référence à tous les services que
      nous proposons via notre site Web (billets),
      <br></br>
      2.7. « Site Internet » désigne notre site Internet Motickets.ma
      <br></br>
      Application mobile » désigne notre application Motickets, disponible en
      versions Android et iOS
      <br></br>
      <br />
      3. Coordonnées de l’entreprise
      <br></br>
      3.1. .motickets.co.uk est un site (« notre site ») exploité par Atendi Ltd
      (« Nous »). Nous sommes immatriculés en Angleterre et au Pays de Galles
      sous le numéro d’entreprise 14185160 et notre siège social est situé au
      150 Midsummer Boulevard, Milton Keynes, MK9 1FD, Angleterre. Nous sommes
      une société anonyme. <br></br>
      3.2. Pour nous contacter, veuillez contact@thebizznez.com envoyer un
      e-mail ou téléphoner à notre service clientèle au +447830006598.<br></br>
      <br></br>
      4. Prix et paiements
      <br></br>
      4.1. Les prix de nos produits sont indiqués en Dirhams marocains toutes
      taxes comprises (TVA et autres taxes applicables au jour de la commande),
      sauf indication contraire. <br></br>
      4.2. Toutes les commandes, quelle que soit leur origine, sont payables en
      Dirhams marocains.
      <br></br>
      4.3 Moticket et ses partenaires se réservent le droit de modifier leurs
      prix à tout moment, ainsi que le droit de modifier les Produits ou
      Services disponibles à la vente sur le Site et l’application mobile,
      <br></br>
      4.4 Le billet pour une manifestation est facturé sur la base du tarif en
      vigueur au moment de la validation de la commande.
      <br></br>
      4.5 Le billet reste la propriété de motickets.ma jusqu’au paiement
      intégral du prix
      <br></br>
      4.6. L’événement relève de la seule responsabilité du producteur ;
      notamment le respect de la réglementation et des lois en vigueur, la
      sécurité des clients, la politique d’accueil, et la procédure de
      remboursement en cas d’annulation. En tant qu’intermédiaire commercial,
      motickets ne saurait être tenu responsable de l’une quelconque de ces
      situations.
      <br></br>
      47. En cas d’annulation, l’organisateur décide du moment du remboursement,
      du montant du remboursement et de la communication autour du remboursement
      aux clients. A titre de frais de service, motickets conservera auprès de
      l’organisateur les commissions initialement versées lors de l’achat du
      billet par le client.
      <br></br>
      4.8 Le paiement s’effectue en ligne via l’application mobile.
      <br></br>
      <br></br>
      5. Achats <br></br>
      5.1. Lorsque vous effectuez un achat sur l’Application mobile, nous
      pouvons vous demander de fournir des informations personnelles (nom,
      numéro de téléphone, adresse de livraison de la facture) <br></br>
      5.2. Assurez-vous que les données que vous avez fournies sont exactes et
      complètes au moment de la passation d’une commande.
      <br></br>
      <br></br>
      6. Le droit à l’effacement de vos données personnelles <br></br>
      6.1. . Vous avez tout à fait le droit de nous demander d’effacer vos
      données personnelles confidentielles. Vous pouvez retirer votre
      consentement à l’utilisation de vos données par voie électronique en
      contactant l’help@motickets.co.uk électronique suivant.
      <br></br>
      <br></br>
      7. Paiement sécurisé par carte bancaire <br></br>
      7.1. Le paiement en ligne sur notre site est sécurisé par la plateforme de
      paiement en ligne CMI. Le système de sécurité des paiements électroniques
      mis en place par CMI, certifié par les banques marocaines ainsi que par
      les organismes internationaux VISA/MASTERCARD. La plateforme CMI vous
      garantit le traitement, en toute confidentialité, de vos données bancaires
      et personnelles conformément aux normes de sécurité en vigueur, ainsi qu’à
      la loi 09-08 relative à la protection des données personnelles.
      <br></br>
      <br></br>
      8. Remboursements
      <br></br>
      8.1. Les demandes de remboursement en cas d’annulation doivent être
      soumises via nos médias fournis par notre équipe. Un délai sera précisé
      pour les demandes de remboursement (généralement une semaine), au-delà
      duquel nous ne pourrons plus accepter les demandes de remboursement. Nous
      vous invitons à consulter cette date limite avant de faire votre demande.
      <br></br>
      8.2. Tous les frais associés à l’achat de billets, y compris, mais sans
      s’y limiter, les frais de traitement, les frais de service, les frais de
      réservation et autres frais connexes, ne sont pas remboursables. En cas
      d’annulation de la commande de billets ou de modification de la
      réservation, les frais susmentionnés ne seront pas remboursés, que
      l’annulation ou la modification soit effectuée par le client ou par
      l’organisateur de l’événement. Les frais d’achat de billets sont
      considérés comme des frais encourus pour le service de réservation et ne
      sont pas remboursables, que la réservation soit utilisée ou non.
      <br></br>
      8.3. Les billets ne sont pas remboursables si l’événement n’est pas
      annulé. Toute demande de remboursement sera refusée dans ce cas, sauf
      circonstances exceptionnelles précisées par l’organisateur.
    </div>
  );
};

export default TermsOfUse;
